import useSwr from "swr";
import { getAmountBreakdown } from "../../wallet/services";
import { GetAmountBreakdownSchema } from "../../wallet/types";
import { PaymentEntityType } from "../../wallet/_components/pay-with-wallet-v2/usePayWithWallet";
import { getCart } from "../services";
import { CartSchema } from "../types";

export function useActiveCart() {
  const {
    data: cart,
    isLoading: cartIsLoading,
    isValidating: cartIsValidating,
    mutate: mutateCart,
  } = useSwr<CartSchema>("cart", getCart);

  // Only define the key if the cart data is ready.
  const amountBreakdownKey =
    !cartIsLoading && cart ? `cart-payment-breakdown` : null;

  const {
    data: amountBreakdown,
    isLoading: amountBreakdownIsLoading,
    isValidating: amountBreakdownIsValidating,
    mutate: mutateAccountBreakdown,
  } = useSwr<GetAmountBreakdownSchema>(amountBreakdownKey, () =>
    getAmountBreakdown(PaymentEntityType.CART, cart?._id || ""),
  );

  return {
    cart,
    cartIsLoading,
    cartIsValidating,
    amountBreakdown,
    mutateCart,
    mutateAccountBreakdown,
    amountBreakdownIsLoading,
    amountBreakdownIsValidating,
  };
}
